import { APONTAMENTO } from '../apontamentoProducao';

export const parseToLegacyRequest = (requisicao) => ({
  ...requisicao,
  folha: requisicao.folha?.id,
  criadoEm: requisicao.criadoEm.format ? requisicao.criadoEm.format('YYYY-MM-DDTHH:mm:ss') : requisicao.criadoEm,
  atualizadoEm: requisicao.atualizadoEm.format
    ? requisicao.atualizadoEm.format('YYYY-MM-DDTHH:mm:ss')
    : requisicao.atualizadoEm,
  [requisicao.tipo === APONTAMENTO.tiposRequisicoes.adiantamento ? 'adiantamentos' : 'mensais']: requisicao.items.map(
    (item) => ({
      ...item,
      requisicao: requisicao.id,
      companyId: requisicao.folha.id,
    })
  ),
  folhaObj: requisicao.folha,
  colaboradores: requisicao.items.map((item) => ({
    ...item,
    ...item.cooperator,
    folhaId: requisicao.folha.id,
    dataAdesao: item.cooperator.accessionDate.split('T')[0],
    dataAfastamento: item.cooperator.removalDate?.split('T')[0] || null,
    descricaoSituacao: item.cooperator.situationDescription,
    assinouContrato: item.cooperator.hasSignedContract,
    criado_em: item.cooperator.hasSignedContract,
    valorHora: item.cooperator.hourlyRate,
    remuneracaoBase: item.cooperator.monthlyEstimate,
  })),
});
